import {
    OBTENER_PROVINCIAS,
    AGREGAR_PROVINCIA,
    ELIMINAR_PROVINCIA,
    ACTUALIZAR_PROVINCIA,
    PROVINCIA_OK,
    PROVINCIA_ERROR,
    PROVINCIA_ACTUAL,
    OBTENER_PROVINCIA,
    LIMPIAR_PROVINCIA
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_PROVINCIAS:
            return {
                ...state,
                provincias: action.payload.rows,
                totalRegistros: action.payload.count
            }
        case LIMPIAR_PROVINCIA:
            return {
                ...state,
                provincias: []
            }
        case PROVINCIA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case PROVINCIA_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_PROVINCIA:
            return {
                ...state,
                provincias: [...state.provincias, action.payload],
                formulario: false,
                errorformulario: false
            }
        case PROVINCIA_ACTUAL:
            return {
                ...state,
                provincia: state.provincias.filter(prov => prov.id === action.payload)
            }
        case ELIMINAR_PROVINCIA:
            return {
                ...state,
                provincias: state.provincias.filter(prov => prov.id !== action.payload),
                provincia: null
            }
        case ACTUALIZAR_PROVINCIA:
            return {
                ...state,
                provincias: state.provincias.map(prov => prov.id === action.payload.id ? action.payload : prov),
                provincia: action.payload
            }
        case OBTENER_PROVINCIA:
            return {
                ...state,
                provincia: action.payload.provincias.rows
            }
        default:
            return state;
    }
}